// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-container[data-v-106c86ed] {\n  padding: 10px;\n  min-height: calc(100% - 10px);\n}", ""]);
// Exports
module.exports = exports;
